export * from './ErrorPage';
export * from './Error500Frontend';

export {default} from './ErrorPage';
